import React from 'react';
export function sliderTrack(value: number, min: number, max: number): string {
  const fill = max === min ? 0 : ((value - min) / (max - min)) * 100;
  return `linear-gradient(90deg, var(--shell-accent) ${fill}%, var(--shell-line) ${fill}%)`;
}

export const SectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="set-kicker">{children}</p>
);

export const SliderField: React.FC<{
  title: string;
  description: string;
  valueLabel: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  minLabel: string;
  maxLabel: string;
  onChange: (value: number) => void;
}> = ({ title, description, valueLabel, min, max, step = 1, value, minLabel, maxLabel, onChange }) => (
  <div className="set-field">
    <div className="set-field__top">
      <div>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <span className="set-chip">{valueLabel}</span>
    </div>
    <input
      className="set-range"
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      aria-label={title}
      aria-valuetext={valueLabel}
      style={{ ['--track' as string]: sliderTrack(value, min, max) }}
      onChange={(event) => onChange(Number(event.target.value))}
    />
    <div className="set-ends">
      <span>{minLabel}</span>
      <span>{maxLabel}</span>
    </div>
  </div>
);

export function SegmentField<T extends string>({
  label,
  description,
  groupLabel,
  value,
  options,
  onChange,
}: {
  label: string;
  description?: string;
  groupLabel: string;
  value: T;
  options: ReadonlyArray<{ id: T; label: string }>;
  onChange: (value: T) => void;
}) {
  return (
    <div className="set-field">
      <div className="set-field__top">
        <div>
          <h3>{label}</h3>
          {description ? <p>{description}</p> : null}
        </div>
        <div className="set-segment" role="group" aria-label={groupLabel}>
          {options.map((option) => (
            <button
              key={option.id}
              type="button"
              aria-pressed={value === option.id}
              onClick={() => onChange(option.id)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export const SwitchRow: React.FC<{
  title: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ title, description, checked, onChange }) => (
  <div className="set-switch">
    <div>
      <strong>{title}</strong>
      <p>{description}</p>
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={title}
      onClick={() => onChange(!checked)}
    >
      <span />
    </button>
  </div>
);
